import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';

const RouteWithLayout = props => {
  const { layout: Layout, component: Component, userProfile, journalMarket, ...rest } = props;

  const userDataSession = {
    userProfile: userProfile,
    journalMarket: journalMarket
  }

  return (
    <Route
      {...rest}
      render={matchProps => (
        <Layout
          {...userDataSession}
        >
          <Component
            {...userDataSession}
            {...matchProps}
          />
        </Layout>
      )}
    />
  );
};

RouteWithLayout.propTypes = {
  component: PropTypes.any.isRequired,
  layout: PropTypes.any.isRequired,
  path: PropTypes.string
};

export default RouteWithLayout;
